import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      // eslint-disable-next-line camelcase
      visit_prescriptions_historyDownload: {
         accessMode: {
            description: {
               pregnant:
                  'Tryb specjalny pobrania historii recept dla kobiet w ciąży w przedziale wiekowym 18-66 lat. Nie wymaga autoryzacji wniosku o dostęp do historii recept.',
               special:
                  'Tryb specjalny pobrania historii recept dla pacjentów, których wiek pozwala na zastosowanie uprawnień seniora "S" lub dziecka "DZ". Nie wymaga autoryzacji wniosku o dostęp do historii recept.',
               standard:
                  'Tryb standardowy pobrania historii recept wymagający autoryzacji dostępu do danych. Pacjent musi posiadać konto w IKP by możliwy był dostęp do historii recept w trybie standardowym.',
            },
            pregnant: 'Tryb specjalny: ciąża',
            special: 'Tryb specjalny',
            standard: 'Tryb standardowy',
         },
         authorizersFetchFailed: 'Błąd pobierania listy osób autoryzujących',
         authorizingPerson: 'Osoba autoryzująca wniosek',
         cantDownloadHistoryForPatientWithoutPESEL: 'Nie można pobrać historii recept dla pacjenta bez numeru PESEL.',
         codeIsInPatientPhoneNotification: 'Kod znajduje się w SMS, który otrzymał pacjent.',
         downloadPrescriptionsHistory: 'Pobierz historię recept',
         goBackToAuthorizerChoice: 'Wróć do wyboru osoby autoryzującej',
         historicalPrescriptionAuthenticationFault:
            'Nie udało się pobrać historii leków. Autoryzacja wygasła. Wypełnij ponownie wniosek o nadanie uprawnień.',
         incorrectCode: 'Niepoprawny kod.',
         max4Digits: 'Maks. 4 cyfry',
         min4Digits: 'Min. 4 cyfry',
         noConfiguredIkp: 'Brak skonfigurowanego IKP',
         p1CommunicationFault: 'Problem z komunikacją z P1',
         patientAuthorizerRelation: {
            ACTUAL_GUARDIAN: 'opiekun faktyczny',
            FATHER: 'ojciec',
            MOTHER: 'matka',
            NEXT_OF_KIN: 'inny krewny',
            NOT_APPLICABLE: 'pacjent',
         },
         patientAuthorizerSelectDisplayValue: '{{firstName}} {{lastName}} ({{relation}})',
         patientCode: 'Kod od pacjenta',
         patientCodePlaceholder: '____',
         patientDidntReceiveNotification: 'Pacjent nie dostał powiadomienia? <goBackToAuthorizerChoiceLink />.',
         prescriptionsHistoryFetchError: 'Wystąpił błąd pobierania listy recept historycznych. Spróbuj ponownie',
         prescriptionsHistoryView: {
            latestHundredPrescriptionsDisplayed: 'Wyświetlono ostatnie 100 recept.',
            noMedicinesIssued: 'Brak wystawionych leków',
            patientHasNoMedicinesIssued: 'Pacjent nie ma żadnych wystawionych leków od dnia {{date}}',
            table: {
               blockingReason: {
                  AGE_OF_PERSON_FOR_WHICH_PRESCRIPTION_EXPRESSED:
                     'Nieodpowiedni wiek osoby, dla której wystawiono receptę.',
                  CHANGING_COMPOSITION_OF_PRESCRIPTIONS: 'Zmiana składu recepty.',
                  EXPIRED_MEDICINE: 'Lek niedopuszczony do obiegu.',
                  IN_IMPLEMENTATION: 'Recepta jest w trakcie realizacji.',
                  ISSUE_OF_DANGER_OF_LIFE_OR_HEALTH: 'Kwestia zagrożenia życia lub zdrowia.',
                  PRODUCT_MAY_BE_USED_FOR_NONMEDICAL_PURPOSES: 'Produkt może być stosowany w celach nieleczniczych.',
               },
               label: {
                  issued: 'Data wystawienia',
                  issuedDate: 'Data realizacji',
                  issuedFrom: 'Realizacja od',
                  medicineName: 'Nazwa handlowa',
                  medicinePackageEan: 'EAN/GTIN',
                  medicineQuantity: 'Opak.',
                  medicineReimbursement: 'Odpł.',
                  package: 'Opakowanie',
                  quantity: 'L. opak.',
                  status: 'Status recepty',
               },
               paperPrescription: 'Papierowa',
               status: {
                  CANCELED: 'Anulowana',
                  EXPOSED: 'Wystawiona',
                  LOCKED: 'Zablokowana',
                  PARTIALLY_COMPLETED: 'Częściowo zrealizowana',
                  REALIZED: 'Zrealizowana',
               },
               statusTooltip: {
                  emptyDate: '-',
                  issuedDate: 'Data realizacji',
                  issuedFrom: 'Realizacja od',
               },
            },
         },
         sendDataAccessRequest: 'Wyślij prośbę o udostępnienie danych',
         tabName: 'eRecepty z P1',
         tryAgain: 'Spróbuj ponownie',
         verify: 'Weryfikuj',
         verifyingPrescriptionsHistoryAccess: 'Weryfikacja dostępu do historii recept pacjenta...',
         weCantVerifyPrescriptionDownloadEntitlement:
            'Nie możemy zweryfikować uprawnień do pobrania historii recept, ponieważ pacjent lub opiekun nie ma konta IKP lub nie ma podanego numeru telefonu w IKP. <goBackToAuthorizerChoiceLink />',
      },
   },
};

export const prescriptionsHistoryDownloadTranslationKeys = createScopedTranslationKeys(
   translations.pl,
   'visit_prescriptions_historyDownload'
);
